import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { syncDocumentHead } from './streamCenterHead';

/** Keeps favicon and document title aligned with LSC vs main Scoutlytics surfaces. */
export function DocumentHeadSync() {
  const { pathname } = useLocation();

  useEffect(() => {
    syncDocumentHead(window.location.hostname, pathname);
  }, [pathname]);

  return null;
}
